import { Dropzone } from "dropzone/dist/dropzone.mjs"
import Sortable from "sortablejs/modular/sortable.core.esm.js"
import "dropzone/dist/dropzone.css"
import "dropzone/dist/basic.css"
import "./main.scss"

export class DropzoneOrdered {
  private static DEBUG: boolean = false

  private url: string
  private urlPreview: string

  private onDataSave: (data: any) => void
  private uploadPhotos: HTMLElement
  private uploadPhotosDropzone: any

  public static setupDropzones = () => {
    const dropzones = document.querySelectorAll(".component-dropzone")
    if (dropzones && dropzones.length > 0) {
      const csrf = document.querySelector("input[name='_csrf']").getAttribute("value")

      for (const dropzone of dropzones) {
        const dropzoneOrdered = new DropzoneOrdered()
        const name = dropzone.getAttribute("data-name")

        dropzoneOrdered.init(
          dropzone as HTMLElement,
          {
            url: dropzone.getAttribute("data-url") ?? location.pathname,
            acceptedFiles: dropzone.getAttribute("data-accepted-files") ?? "*/*",
            paramName: dropzone.getAttribute("data-name"),
            addRemoveLinks: dropzone.getAttribute("data-add-remove-links") == "true",
            parallelUploads: parseInt(dropzone.getAttribute("data-parallel-uploads") ?? "5"),
            maxFilesize: parseInt(dropzone.getAttribute("data-max-file-size-mb") ?? "1"),
            maxFiles: parseInt(dropzone.getAttribute("data-max-files") ?? "10")
          },
          csrf,
          document.querySelector("input[name='" + name + "']").getAttribute("value"),
          (data) => {
            document.querySelector("input[name='" + name + "']").setAttribute("value", data)
          }
        )
      }
    }
  }

  constructor() {}

  public init = (dropzoneElement: HTMLElement, dropzoneOptions: any, csrf: any, dataToLoad: any, onDataSave: (data: any) => void) => {
    this.url = dropzoneOptions.url
    this.urlPreview = dropzoneOptions.urlPreview || dropzoneOptions.url

    this.onDataSave = onDataSave
    this.uploadPhotos = dropzoneElement

    this.uploadPhotosDropzone = new Dropzone(this.uploadPhotos, dropzoneOptions)

    this.populateExistingData(dataToLoad)
    this.addSortability()

    this.uploadPhotosDropzone.on("sending", (file, xhr, formData) => {
      formData.append("_csrf", csrf)
    })

    this.uploadPhotosDropzone.on("success", (file, response) => {
      file.upload.key = response
      let thumbnailUrl = this.urlPreview + "/" + response
      file.dataURL = thumbnailUrl
      this.uploadPhotosDropzone.emit("thumbnail", file, thumbnailUrl)
      this.updatePhotoData()
    })

    this.uploadPhotosDropzone.on("removedfile", (file) => {
      this.updatePhotoData()

      if (!file || !file.upload || !file.upload.key) return

      // Call endpoint and remove photo if it's not used anywhere else
      fetch(this.url + "/" + file.upload.key, {
        method: "DELETE",
        body: JSON.stringify({
          _csrf: csrf
        })
      })
        .then((response) => {
          // Ignore
        })
        .catch((error) => {
          // Ignore
        })
    })
  }

  private updatePhotoData = () => {
    let photos = []

    for (let file of this.uploadPhotosDropzone.files) {
      if (!file || !file.upload || !file.upload.key) continue
      let data = {
        key: file.upload.key,
        name: file.upload.filename,
        sizeBytes: file.upload.total
      }
      photos.push(data)
    }

    if (DropzoneOrdered.DEBUG) console.info("Dropzone keys order: ", photos)

    let photosData = JSON.stringify(photos)
    if (this.onDataSave) this.onDataSave(photosData)
  }

  private populateExistingData = (dataToLoad: any) => {
    if (!!dataToLoad && dataToLoad.length > 0) {
      if (typeof dataToLoad === "string") dataToLoad = JSON.parse(dataToLoad)
    } else {
      dataToLoad = []
    }

    for (let data of dataToLoad) {
      let url = this.urlPreview + "/" + data.key

      let mimeType = data.mimetype
      if (mimeType) {
        if (!mimeType.includes("image")) mimeType = "image/" + mimeType
      } else {
        mimeType = "image/*"
      }

      let file = {
        key: data.key,
        name: data.name,
        size: data.sizeBytes,
        type: mimeType,
        status: Dropzone.ADDED,
        url: url,
        upload: {
          key: data.key,
          filename: data.name,
          total: data.sizeBytes
        }
      }

      this.uploadPhotosDropzone.files.push(file)
      this.uploadPhotosDropzone.emit("addedfile", file)
      this.uploadPhotosDropzone.emit("thumbnail", file, url)
      this.uploadPhotosDropzone.emit("complete", file)
    }
  }

  private addSortability = () => {
    let sortable = new Sortable(this.uploadPhotos, {
      draggable: ".dz-preview",
      animation: 150,
      onStart: (evt) => {
        evt.item.dataset.dragStartPos = evt.oldIndex.toString()
      },
      onSort: (evt) => {
        evt.item.dataset.dragFinishPos = evt.newIndex.toString()

        let startPos = Number(evt.item.dataset.dragStartPos) - 1
        let finishPos = Number(evt.item.dataset.dragFinishPos) - 1

        startPos = Math.max(0, startPos)
        finishPos = Math.min(this.uploadPhotosDropzone.files.length - 1, finishPos)

        if (DropzoneOrdered.DEBUG) console.info("Moved from:: ", startPos, " to ", finishPos)

        // Move files
        let element = this.uploadPhotosDropzone.files[startPos]
        this.uploadPhotosDropzone.files.splice(startPos, 1)
        this.uploadPhotosDropzone.files.splice(finishPos, 0, element)

        this.updatePhotoData()
      }
    })
  }
}
